import { useUserOrKioskQuery } from "../common/lib/fetch";
import { QueryOptions } from "../common/lib/fetch/useQuery";
import { ResultError } from "../common/Result";

export interface ReprintStatusResponse {
  id: string,
  requestedAt: string,
  acknowledgedAt: string | null,
  succeeded: boolean | null,
  error: ResultError | null,
}

export const useGetReprintStatus = (stagedOrderId: string, options: QueryOptions<ReprintStatusResponse>) =>
  useUserOrKioskQuery<ReprintStatusResponse>({
    path: `/api/pastOrders/${stagedOrderId}/reprint/status`
  }, options);
